import { createContext } from "react";

/**
 * Element in the task page header that the filing form renders its pending
 * count into, so the count can live inside the form and stay in sync with it.
 */
export const TaskHeaderSlotContext = createContext<HTMLElement | null>(null);
